var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.visible,
        width: "552px",
        "append-to-body": true,
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "fix-form" },
        [
          _c(
            "el-radio-group",
            {
              staticClass: "check-group",
              model: {
                value: _vm.groupId,
                callback: function ($$v) {
                  _vm.groupId = $$v
                },
                expression: "groupId",
              },
            },
            _vm._l(_vm.list, function (item, index) {
              return _c(
                "el-radio",
                {
                  key: index,
                  attrs: {
                    label: item.id,
                    disabled: _vm.currentGroupId === item.id,
                  },
                },
                [_vm._v(_vm._s(item.name))]
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                loading: _vm.btnLoading,
                disabled: _vm.currentGroupId == _vm.groupId,
              },
              on: { click: _vm.save },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }